import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'quiz-ui', {
    viewResult: 'View Result',
    changeMyAnswer: 'Change my answer',
    next: 'Next >',
    questionScoreYourAnswer: 'Your answer: {{answer}}',
    questionScoreBestAnswer: 'Best answer: {{answer}}',
    questionScorePoints: '{{score}} / {{max}} points',
    typeYourAnswerHere: 'Type your answer here...',
    newLine: 'New line:',
    editDescriptionAndInstructions: 'Edit Description & Instructions',
    saveDescriptionAndInstructions: 'Save Description & Instructions',
    publishSelectedQuizzes: 'Publish selected quizzes',
    unpublishSelectedQuizzes: 'Unpublish selected quizzes',
    archiveSelectedQuizzes: 'Archive selected quizzes',
    unarchiveSelectedQuizzes: 'Unarchive selected quizzes',
    trashSelectedQuizzes: 'Trash selected quizzes',
    deleteSelectedQuizzes: 'Delete selected quizzes',
    startQuiz: 'Start quiz',
    trashQuiz: 'Trash quiz',
    deleteQuiz: 'Delete quiz',
    noAnswers: 'No answers',
    filterQuestion: 'Filter question',
    filterValues: 'Filter values',
    autoFill: 'Auto fill',
    quizResultNotFound: 'Quiz result not found.',
    trashQuizResult: 'Trash quiz result',
    duplicateQuizResult: 'Duplicate quiz result',
    scoreQuizResult: 'Score quiz result',
    deleteQuizResult: 'Delete quiz result',
    quizResults: 'Quiz Results',
    quizCompletedAnalyzing:
      'You have completed the quiz and your results are being analyzed. Please check back soon.',
    goToFirstSkippedQuestion: 'Go to first skipped question',
    submitQuizAnswers: 'Submit Quiz Answers',
    unansweredQuestionsBeforeSubmit: 'Answer these questions before submitting: {{questions}}',
    reviewYourAnswers: 'Review Your Answers',
    continueLater: 'Continue later',
    questionOfTotal: 'Question {{current}} of {{total}}',
    quizSummary: 'Quiz Summary',
    uploadJsonFiles: 'Upload JSON files',
    quizNotFound: 'Quiz not found',
    descriptionAndInstructionsUpdated: 'Description and instructions updated',
    cancel: 'Cancel',
    trash: 'Trash',
    delete: 'Delete',
    discard: 'Discard',
    nounQuiz: 'Quiz',
    nounQuizzes: 'Quizzes',
    trashQuizConfirmTitle: 'Trash Quiz',
    trashQuizConfirmDescription: 'Are you sure you want to send "{{name}}" to the trash?',
    quizMovedToTrash: 'Quiz moved to the trash',
    quizRestoreFailed: 'Could not restore the quiz',
    quizPublishedSuccessfully: 'Quiz published successfully',
    quizUnpublishedSuccessfully: 'Quiz unpublished successfully',
    quizArchivedSuccessfully: 'Quiz archived successfully',
    quizUnarchivedSuccessfully: 'Quiz unarchived successfully',
    deleteQuizConfirmTitle: 'Delete Quiz',
    deleteQuizConfirmDescription:
      'Are you sure you want to permanently delete the quiz "{{name}} version {{version}}" and all related quiz results? This action cannot be undone.',
    quizzesMovedToTrash: '{{count}} quiz moved to the trash',
    quizzesMovedToTrash_plural: '{{count}} quizzes moved to the trash',
    quizzesDeleted: 'Deleted {{count}} quiz',
    quizzesDeleted_plural: 'Deleted {{count}} quizzes',
    quizResultDuplicated: 'Quiz result duplicated',
    trashQuizResultConfirmTitle: 'Trash Quiz Result',
    trashQuizResultConfirmDescription:
      'Are you sure you want to send this quiz result to the trash?',
    quizResultMovedToTrash: 'Quiz result moved to the trash',
    quizResultRestoreFailed: 'Could not restore the quiz result',
    deleteQuizResultConfirmTitle: 'Delete Quiz Result',
    deleteQuizResultConfirmDescription:
      'Are you sure you want to permanently delete the selected quiz result? This action cannot be undone.',
    quizResultDeletedSuccessfully: 'Quiz result deleted successfully',
    failedToSaveAnswer: 'Failed to save your answer. Please try again.',
    failedToContinueQuiz: 'Failed to continue the quiz',
    failedToStartQuiz: 'Failed to start the quiz',
    pauseQuizConfirmTitle: 'Pause Quiz',
    pauseQuizConfirmDescription: 'Are you sure you want to pause the quiz and continue it later?',
    discardAnswersConfirmTitle: 'Discard answers',
    discardAnswersConfirmDescription:
      'Are you sure you want to permanently delete the answers you have already completed? This cannot be undone.',
    answersDiscarded: 'Answers discarded',
  });
}
